module.exports = __webpack_public_path__ + "resources/globe/earthquakes-2015.csv";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=resources/globe/earthquakes-2015.csv!./src/resources/globe/earthquakes-2015.csv
// module id = 2504
// module chunks = 0